import { Injectable } from '@angular/core';

import { Logger } from './logger.service';
import { LogContext } from './logger.types';

@Injectable({
  providedIn: 'root',
})
export class ConsoleLoggerService implements Logger {
  public debug(message: string, context: LogContext = {}): void {
    console.debug(message, context);
  }

  public info(message: string, context: LogContext = {}): void {
    console.info(message, context);
  }

  public warn(message: string, context: LogContext = {}): void {
    console.warn(message, context);
  }

  public error(message: string, context: LogContext = {}): void {
    console.error(message, context);
  }
}
